import { Controller } from "@hotwired/stimulus"
import { diffString } from "json-diff"

export default class extends Controller {
  static targets = ["output"]
  static values = {
    json1: Object,
    json2: Object
  }

  connect() {
    this.renderDiff()
  }

  renderDiff() {
    const json1 = this.json1Value || {}
    const json2 = this.json2Value || {}

    try {
      const result = diffString(json1, json2, { color: false })
      if (result && result.trim() !== "") {
        this.outputTarget.textContent = result
      } else {
        this.outputTarget.textContent = "Nenhuma diferença encontrada."
      }
    } catch (e) {
      this.outputTarget.textContent = "Erro ao calcular diferenças: " + e.message
    }
  }
}
